import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import httpService from "../services/httpService";
import { useUiStore } from "../store/store";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Badge from "react-bootstrap/Badge";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { FaSpinner } from "react-icons/fa6";
import { FaCog, FaHeadphones, FaChartBar, FaUsers, FaComments, FaEnvelopeOpen, FaCommentDots, FaCalendarAlt, FaClipboardList } from 'react-icons/fa';
import PageHero from "../components/PageHero";
import SkillScrollCarousel from "../components/SkillScrollCarousel";

import "../styles/dashbaords.scss";
import LoadingFade from "../components/LoadingFade";
import Heading3 from "../components/Heading3";
import PracticesChart from "../components/PracticesChart";
import SkillsRadarChart from "../components/SkillsRadarChart";
import PodcasterEpisodeItem from "../components/PodcasterComponents/PodcasterEpisodeItem";
import EpisodeModalComponent from "../components/clubWizard/EpisodeModalComponent";
import EpisodeUsersData from "../components/PodcasterComponents/EpisodeUsersData";
import EpisodeTakeawaysData from "../components/PodcasterComponents/EpisodeTakeawaysData";
import ClubEpisodes from "../components/PodcasterComponents/ClubEpisodes";
import ClubSettings from "../components/PodcasterComponents/ClubSettings";
import ClubStatistics from "../components/PodcasterComponents/ClubStatistics";
import ClubUsers from "../components/PodcasterComponents/ClubUsers";
import ClubDiscussion from "../components/PodcasterComponents/ClubDiscussion";
import ClubInvites from "../components/PodcasterComponents/ClubInvites";
import ClubSchedule from "../components/PodcasterComponents/ClubSchedule";
import PodcasterPodcastClubSharedPractices from "../components/PodcasterComponents/PodcasterPodcastClubSharedPractices";
import Image from "react-bootstrap/Image";

const PodcasterPodcastClub = () => {
    const { guid } = useParams();
    const [loading, setLoading] = useState(true);
    const [generatingData, setGeneratingData] = useState(false);
    const [club, setClub] = useState(null);
    const [practiceSkills, setPracticeSkills] = useState([]);
    const [error, setError] = useState(null);
    const [selectedEpisode, setSelectedEpisode] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showUsersModal, setShowUsersModal] = useState(false);
    const [activeTab, setActiveTab] = useState('episodes');
    const [imgCacheBuster, setImgCacheBuster] = useState(() => Date.now());
    const [showOnboardingModal, setShowOnboardingModal] = useState(false);
    const { showPodcasterPodcastClubOnboardingVideo, setShowPodcasterPodcastClubOnboardingVideo } = useUiStore();

    useEffect(() => {
        if (guid) {
            getClubData();
            if (showPodcasterPodcastClubOnboardingVideo) {
                httpService.get(`/dash/podcast-club/${guid}/is-only-club`)
                    .then((res) => {
                        if (res.data.is_only_club) setShowOnboardingModal(true);
                    });
            }
        }
    }, [guid]);

    const getClubData = () => {
        httpService.get(`/dash/podcast-club/${guid}`)
            .then((res) => {
                console.log('get club data', res.data);
                setClub(res.data.podcast_club || null);
                setPracticeSkills(res.data.practice_skills || null);
            })
            .catch((err) => {
                setError(err.response?.data?.message || "Error loading podcast club data");
            })
            .finally(() => setLoading(false));
    };

    const handleEditEpisode = (episode) => {
        setSelectedEpisode(episode);
        setShowEditModal(true);
    };

    const handleViewUsers = (episode) => {
        setSelectedEpisode(episode);
        setShowUsersModal(true);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setSelectedEpisode(null);
    };

    const handleCloseUsersModal = () => {
        setShowUsersModal(false);
        setSelectedEpisode(null);
    };

    const reloadClub = () => {
        setImgCacheBuster(Date.now());
        getClubData();
    };

    useEffect(() => {
        if (club && !club.accessible_by_invite && activeTab === 'invites') {
            setActiveTab('episodes');
        }
    }, [club]);

    const handleCloseOnboardingModal = () => {
        setShowOnboardingModal(false);
        setShowPodcasterPodcastClubOnboardingVideo(false);
    };

    const handleGenerateDummyData = async () => {
        setGeneratingData(true);
        try {
            await httpService.post(`/dash/club/${guid}/generate-dummy-data`);
            await getClubData();
        } catch (err) {
            setError(err.response?.data?.message || "Error generating dummy data");
        } finally {
            setGeneratingData(false);
        }
    };

    return (
        <LoadingFade loading={loading} stateKey={loading ? 'loading' : 'not-loading'}>

            {club && (
                <PageHero
                    backgroundImage={`${club.super_wide_image || '/img/club-defaults/super-wide.jpg'}?t=${imgCacheBuster}`}
                >
                    <div>
                        <h1 className="page-hero__title mb-1">{club.title}</h1>
                        <p className="page-hero__sub mb-0">{club.description}</p>
                        <div className="mt-2">
                            <span className="badge bg-light text-dark" style={{ fontSize: '0.72rem' }}>
                                <FaUsers className="me-1" />{club.total_listeners || 0} listeners
                            </span>
                        </div>
                    </div>
                </PageHero>
            )}

            <Container className={'my-3 component-PodcasterPodcastClub'}>
                <Row>
                    <Col sm={12}>
                        {error && (
                            <div className="alert alert-danger">{error}</div>
                        )}

                        {!club && !error && (
                            <p className="text-muted">Podcast club not found.</p>
                        )}

                        {club && (
                            <Card className="mb-4">
                                <Card.Body>
                                    {/* Club Info */}


                                    {/* Practice Skills as Badges */}
                                    {practiceSkills && practiceSkills.length > 0 && (
                                        <div className="mb-3">
                                            {/*<h4>Practice Skills:</h4>*/}
                                            <SkillScrollCarousel skills={practiceSkills} />
                                        </div>
                                    )}

                                    {/* Tabs */}
                                    <Tabs
                                        activeKey={activeTab}
                                        onSelect={(k) => setActiveTab(k)}
                                        className="mb-3"
                                        id="club-tabs"
                                    >
                                        <Tab eventKey="settings" title={<span><FaCog className="me-1" />Settings</span>}>
                                            {activeTab === 'settings' && (
                                                <ClubSettings
                                                    clubGuid={guid}
                                                    reloadClub={reloadClub}
                                                />
                                            )}
                                        </Tab>
                                        <Tab eventKey="episodes" title={<span><FaHeadphones className="me-1" />Episodes</span>}>
                                            {activeTab === 'episodes' && (
                                                <ClubEpisodes
                                                    clubGuid={guid}
                                                    onEditEpisode={handleEditEpisode}
                                                    onViewUsers={handleViewUsers}
                                                />
                                            )}
                                        </Tab>
                                        <Tab eventKey="statistics" title={<span><FaChartBar className="me-1" />Statistics</span>}>
                                            {activeTab === 'statistics' && (
                                                <ClubStatistics clubGuid={guid} />
                                            )}
                                        </Tab>
                                        <Tab eventKey="users" title={<span><FaUsers className="me-1" />Listeners</span>}>
                                            {activeTab === 'users' && (
                                                <ClubUsers clubGuid={guid} />
                                            )}
                                        </Tab>
                                        {/*<Tab eventKey="forum" title={<span><FaComments className="me-1" />Discussions</span>}>*/}
                                        {/*    {activeTab === 'forum' && (*/}
                                        {/*        <ClubDiscussion clubGuid={guid} />*/}
                                        {/*    )}*/}
                                        {/*</Tab>*/}
                                        <Tab eventKey="schedule" title={<span><FaCalendarAlt className="me-1" />Club Schedule</span>}>
                                            {activeTab === 'schedule' && (
                                                <ClubSchedule clubGuid={guid} />
                                            )}
                                        </Tab>
                                        <Tab eventKey="shared-practices" title={<span><FaClipboardList className="me-1" />Shared Practices</span>}>
                                            {activeTab === 'shared-practices' && (
                                                <PodcasterPodcastClubSharedPractices clubGuid={guid} />
                                            )}
                                        </Tab>
                                        {!!club.accessible_by_invite && (
                                            <Tab eventKey="invites" title={<span><FaEnvelopeOpen className="me-1" />Invites</span>}>
                                                {activeTab === 'invites' && (
                                                    <ClubInvites
                                                        clubGuid={guid}
                                                        title={club.title}
                                                        description={club.description}
                                                        image={`${club.super_wide_image || '/img/club-defaults/super-wide.jpg'}?t=${imgCacheBuster}`}
                                                    />
                                                )}
                                            </Tab>
                                        )}
                                    </Tabs>

                                </Card.Body>
                            </Card>
                        )}
                    </Col>
                </Row>
            </Container>

            {/* Edit Episode Modal */}
            <Modal
                size="lg"
                show={showEditModal}
                onHide={handleCloseEditModal}
                backdrop="static"
                keyboard={false}
                id={'EpisodeTakeawaysDataModal'}
            >
                <Modal.Header style={selectedEpisode?.pivot?.color ? { borderTop: '10px solid '+ selectedEpisode?.pivot?.color } : {}} closeButton>
                    {/*<Modal.Title>Edit Episode</Modal.Title>*/}
                </Modal.Header>
                <Modal.Body>
                    {/*{selectedEpisode && <EpisodeTakeawaysData episode={selectedEpisode} />}*/}
                    {selectedEpisode && <EpisodeModalComponent episode={selectedEpisode} />}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={handleCloseEditModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Users Data Modal */}
            <Modal
                size="lg"
                show={showUsersModal}
                onHide={handleCloseUsersModal}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header style={selectedEpisode?.pivot?.color ? { borderTop: '10px solid '+ selectedEpisode?.pivot?.color } : {}} closeButton>
                    {/*<Modal.Title>Episode Users Data</Modal.Title>*/}
                </Modal.Header>
                <Modal.Body>
                    {selectedEpisode && <EpisodeUsersData episode={selectedEpisode} clubGuid={guid} />}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={handleCloseUsersModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Onboarding Video Modal */}
            <Modal show={showOnboardingModal} onHide={handleCloseOnboardingModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Welcome to your first Podcast Club!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                        <iframe
                            src="https://www.loom.com/embed/18c03d1bcbda49c1ac4b6a7c57356048?autoplay=1"
                            frameBorder="0"
                            webkitAllowFullScreen
                            mozAllowFullScreen
                            allowFullScreen
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                            title="Welcome to Podsy"
                        />
                    </div>
                </Modal.Body>
            </Modal>

        </LoadingFade>
    );
};

export default PodcasterPodcastClub;